
export default {
    methods: {
        selectComponent() {
            this.$root.$emit('selectComponent', {
                componentSelected: '',
            })
        }
    }
}